import React from "react";
import BaseModal from "../BaseModal";
import {Button, Col, Modal, Row, Spinner} from "react-bootstrap";
import {useDispatch, useSelector} from "react-redux";
import {
    actionChangeLoaderCancelModalInvoice,
    actionChangeStatusModalInvoice
} from "../../../../../redux/actions/modals/modalInvoice/modalInvoice";
import {actionAddItemInSHoppingCard, 
    actionRefreshModalShoppingCard, 
    actionGatDaysInAPiFOrModalShoppingCart} from "../../../../../redux/actions/modals/modalShoppingCard";
import {handelOpenModalEditDateTime, handelToggleLoaderModal} from "../../../../../redux/actions/modals/editOrder/modalEditDateTime.js";
import Steps, {Step} from "rc-steps";
import CardItemModalBasketCartProduct from "../../card/CardItemModalBasketCartProduct";
import axios from "axios";
import {BASE_URL, ORDER_CANCEL_POST, USERS_ADDRESS_GET, ORDER_GET_DELIVERY_TIMES_FOR_EDIT, URL_ORDER_GET_QUS_GRATUITY, PUBLIC_URL_SERVER} from "../../../../../apis";
import qs from "querystring";
import swal from 'sweetalert';
import Swal from 'sweetalert2';
import {FaCheck, FaEdit, FaTimes} from "react-icons/all";
import {useHistory} from "react-router-dom";
import {
    actionModalChangeAddressChangeLoader,
    actionModalChangeAddressChangeShow
} from "../../../../../redux/actions/modals/modalChangeAddress";
import {
    handelOpenModalEditDescGratuity,
    handelToggleLoaderModalDescGratuity,
    handelChangeOrderDescGratuity
} from "../../../../../redux/actions/modals/editOrder/modalEditDescGratuity.js";
// import {actionGetAddressUser, actionSelectItemActiveAddress} from "../../../../../redux/actions/user/user";
import {actionGetAddressUser} from "../../../../../redux/actions/user/user";
import {actionChangeActiveSelectTablePostSchedule, actionChangeActiveDayPostSchedule} from "../../../../../redux/actions/modals/modalShoppingCard";

const ModalInvoice = () => {
    const {statusShow, order,cancelLoader} = useSelector(state => state.modalInvoice);

    let history = useHistory();
    const {carts} = useSelector(state => state.shoppingCart);

    const {token} = useSelector(state => state.user);
    const dispatch = useDispatch();
    const handleClose = () => {
        dispatch(actionChangeStatusModalInvoice(false));
    };

    const btnOkSingle = Swal.mixin({
        customClass: {
            confirmButton: 'base-btn-green-border btn btn-success',
        },
        buttonsStyling: false
    });

    const buttonsOkCancel = Swal.mixin({
            customClass: {
                confirmButton: 'modal-carrot-btn-successbase-btn-green btn btn-success ml-4',
                cancelButton: 'base-btn-green-border btn btn-success',
            },
            buttonsStyling: false
        });

    const handleCancelOrder = () => {
        
        buttonsOkCancel.fire({
            text: "آیا میخواهید این سفارش را لغو کنید؟",
            imageUrl: PUBLIC_URL_SERVER + '/icons/fm_logo_ofoghi_new.png',
            imageHeight: 45,
            imageAlt: 'فروت مروت',
            confirmButtonText: "بله",
            showCancelButton: true,
            cancelButtonText: 'انصراف',
        }).then((result) => {
            if (result.isConfirmed) {
                startHandleCancelOrder();
            }
        });
    };

    const startHandleCancelOrder = () =>{
        dispatch(actionChangeLoaderCancelModalInvoice(true));
        axios({
            method: 'post',
            url: BASE_URL + ORDER_CANCEL_POST,
            data: qs.stringify({
                order: order.order,
            }),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': token
            },
        }).then((response) => {
            if (response.data.status === 'ok') {
                handleClose();
                btnOkSingle.fire({
                    title: "لغو سفارش",
                    text: `سفارش با موفقیت لغو شد.`,
                    imageUrl: PUBLIC_URL_SERVER + '/icons/fm_logo_ofoghi_new.png',
                    imageHeight: 45,
                    imageAlt: 'فروت مروت',
                    confirmButtonText: "تایید",
                });
            } else {
                swal({
                    title: "لغو سفارش",
                    text: `لطفا مجددا تلاش کنید.`,
                    buttons: {
                        cancel: "تایید",
                    },
                    icon: "error",
                });
            }
            dispatch(actionChangeLoaderCancelModalInvoice(false));
        });
    };

    const handleEditTime = () => {
        // handleComingCoon();

        dispatch(handelOpenModalEditDateTime());
        dispatch(handelToggleLoaderModal(true));

        handleGetTimesInApi();

    };

    const handleGetTimesInApi = () => {
        let data = {order: order.order};
        
        axios({
            method: 'post',
            url: BASE_URL + ORDER_GET_DELIVERY_TIMES_FOR_EDIT,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': token,
            },
            data: qs.stringify(data),
        }).then((response) => {
            dispatch(handelToggleLoaderModal(false));
            if (response.data.status === 'ok') {
                dispatch(actionGatDaysInAPiFOrModalShoppingCart(response.data));
                if(response.data.selected_time !== undefined) {
                    setTimeout(() => {
                        dispatch(actionChangeActiveSelectTablePostSchedule(response.data.selected_time));
                        dispatch(actionChangeActiveDayPostSchedule(response.data.day_selected));
                    }, 400);
                }
            }
        });
    };

    

    const handleEditInvoice = () => {
        // handleComingCoon();
        if (carts.length > 0) {
            buttonsOkCancel.fire({
                title: "توجه",
                text: 'شما در حال ثبت یک سفارش جدید بوده اید، برای ویرایش لیست سفارش قبلی خود، سبد خرید فعلی شما پاک میشود. آیا مایل به ویرایش سفارش هستید؟',
                imageUrl: PUBLIC_URL_SERVER + '/icons/fm_logo_ofoghi_new.png',
                imageHeight: 45,
                imageAlt: 'فروت مروت',
                confirmButtonText: "بله",
                showCancelButton: true,
                cancelButtonText: 'انصراف',
            }).then((result) => {
                if (result.isConfirmed) {
                    dispatch(actionRefreshModalShoppingCard());
                    addProductsToShoppingCart();
                }
            });
        } else {
            addProductsToShoppingCart();
        }

        
    };

    const addProductsToShoppingCart = () => {
        order.basket.forEach(productItem => {
            let grades = [{
                default: productItem.default,
                gradeId: productItem.productGradeId,
                gradeTitle: productItem.grade_title,
                inventory: productItem.inventory,
                marketPrice: productItem.marketPrice,
                min_amount: productItem.min_amount,
                ourPrice: productItem.ourPrice,
                unit: productItem.unit,
            }];
            let data = {
                category_id: order.shopId, 
                category_title: order.shopTitle,
                desc_show: productItem.desc_show,
                description: productItem.description,
                grade_header: "",
                grade_title: productItem.grade_title, 
                grades: grades, 
                images: [productItem.image], 
                name: productItem.title, 
                productId: productItem.productId, 
            }

            grades[0].number_input = productItem.selectedAmount;
            let selectGrade = grades[0]; 
            selectGrade.forFoodPack = productItem.for_food_pack;
            dispatch(actionAddItemInSHoppingCard(data, selectGrade, productItem.selectedAmount, null));
        });

        dispatch(actionChangeStatusModalInvoice(false));
        localStorage.setItem('editOrderMode', order.order);
        history.push(`/stores/${order.shopId}`); 
    };

    const handleEditAddress = () => {
        // handleComingCoon();

        apiHandelGetAddress();
        dispatch(actionModalChangeAddressChangeShow(true, 'home', true));
    };

    const apiHandelGetAddress = () => {
        dispatch(actionModalChangeAddressChangeLoader(true));
        axios({
            method: 'post',
            url: BASE_URL + USERS_ADDRESS_GET,
            data: qs.stringify({
                order : order.order,
            }),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': token
            },
        }).then((response) => {
            dispatch(actionModalChangeAddressChangeLoader(false));

            if(response.data.status === "ok") {
                dispatch(actionGetAddressUser(response.data.address));

                // if(order.selectInEditMode === undefined || order.selectInEditMode === null)
                // {
                //     response.data.address.forEach(addressItem => {
                //         if(addressItem.selectThis)
                //             dispatch(actionSelectItemActiveAddress(addressItem));
                //     });
                // }
                    
            } 
        });
    };

    const handleEditDescGratuity = () => {
        apiHandelGetOrderDescGratuity();
        dispatch(handelOpenModalEditDescGratuity());
    };

    const apiHandelGetOrderDescGratuity = () => {
        dispatch(handelToggleLoaderModalDescGratuity(true));
        axios({
            method: 'post',
            url: BASE_URL + URL_ORDER_GET_QUS_GRATUITY,
            data: qs.stringify({
                order : order.order,
            }),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': token
            },
        }).then((response) => {
            dispatch(handelToggleLoaderModalDescGratuity(false));

            if(response.data.status === "ok") {
                dispatch(handelChangeOrderDescGratuity(response.data.description, response.data.gratuity));
            } 
        });
    };



    // const handleComingCoon = () => {
    //     toast.warning(`این سرویس درحال حاظر در دسترس نمیباشد.`, {
    //         position: toast.POSITION.BOTTOM_CENTER
    //     });
    // };

    return (
        <>
            <BaseModal title={`شماره فاکتور : ${order.order ? order.order : ''}`}
                       show={statusShow}
                       dialogClassName={''}
                       handleClose={handleClose}>
                <Modal.Body>
                    <ul className={'list-ul-modal-invoice'}>
                        <li className={'item-li-modal-invoice'}>
                            <div className={'head-item-li-modal-invoice'}>
                                <h6>وضعیت سفارش</h6>
                            </div>
                            <div style={{fontSize: 6, display: "flex"}}>
                                {typeof order.order_status !== "undefined" && order.order_status.length > 0 ?
                                    <Steps size={'small'} icons={{
                                        finish: <FaCheck/>,
                                        error: <FaTimes/>
                                    }} status={`process`} initial={0} labelPlacement={`vertical`}
                                           iconPrefix={' glyphicon glyphicon-cloud '}>
                                        {order.order_status.map((item, index) => {
                                            return (
                                                <Step key={index} title={<span>{item.title}</span>}
                                                     status={item.done ? 'finish' :'wait' }
                                                      disabled={!item.done}
                                                      active={item.done}
                                                />
                                            );
                                        })}
                                    </Steps>
                                    : ''}
                            </div>
                        </li>
                        <li className={'item-li-modal-invoice'}>
                            <Row>
                                <Col xs={9}>
                                    <span>زمان ارسال : </span>
                                    <span> {order.delivery_time} </span>
                                </Col>
                                <Col xs={3}>
                                    <div className={'box-btn-edits-modal-invoice'}>
                                        <div className={'btn-edits-modal-invoice'} onClick={handleEditTime}>
                                            <FaEdit/>
                                            <span>ویرایش</span>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </li>
                        <li className={'item-li-modal-invoice'}>
                            <Row>
                                <Col xs={9}>
                                    <div>
                                        <span>آدرس : </span>
                                        <span>{order.address}</span>
                                    </div>
                                </Col>
                                <Col xs={3}>
                                    <div className={'box-btn-edits-modal-invoice'}>
                                        <div className={'btn-edits-modal-invoice'} onClick={handleEditAddress}>
                                            <FaEdit/>
                                            <span>ویرایش</span>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </li>
                        <li className={'item-li-modal-invoice'}>
                            <Row>
                                <Col xs={9}>
                                    <div>
                                        <span>توضیحات: </span>
                                        <span>{order.order_description}</span>
                                    </div>
                                    <div>
                                        <span>انعام: </span>
                                        <span>{order.gratuity !== "0" ? (parseInt(order.gratuity).toLocaleString() + " تومان") : order.gratuity}</span>
                                    </div>
                                </Col>
                                <Col xs={3}>
                                    <div className={'box-btn-edits-modal-invoice'}>
                                        <div className={'btn-edits-modal-invoice'} onClick={handleEditDescGratuity}>
                                            <FaEdit/>
                                            <span>ویرایش</span>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </li>
                        <li className={'item-li-modal-invoice'}>
                            <Row>
                                <Col xs={9}>
                                    <div className={'head-item-li-modal-invoice'}>
                                        <h6>لیست سفارش</h6>
                                    </div>
                                </Col>
                                <Col xs={3}>
                                    <div className={'box-btn-edits-modal-invoice'}>
                                        <div className={'btn-edits-modal-invoice'} onClick={handleEditInvoice}>
                                            <FaEdit/>
                                            <span>ویرایش</span>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            <div>
                                {order.basket !== undefined ? order.basket.map((product, index) => {
                                    return (
                                        <CardItemModalBasketCartProduct
                                            key={index}
                                            data={{
                                                product: {
                                                    name: product.title,
                                                    image: product.image,
                                                    unit: product.amount,
                                                    price: product.price,
                                                    gradeTitle:product.grade_title
                                                }
                                            }}
                                            showEdit={false}/>
                                    );
                                }) : ''}
                            </div>
                        </li>
                    </ul>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-danger" block onClick={handleCancelOrder} disabled={cancelLoader}>
                        <span>لغو سفارش</span>
                        {cancelLoader ?
                            <Spinner className={'mb-1 ml-2'}
                                     animation="border" size="sm"
                                     variant="danger"/>
                            : ''
                        }
                    </Button>
                </Modal.Footer>
            </BaseModal>
        </>
    );
};

export default React.memo(ModalInvoice);
